import { c as _c } from "react/compiler-runtime";
import { ReactNode } from "react";
interface IconTextLayoutProps {
  children: ReactNode;
}
export const IconTextLayout: React.FC<IconTextLayoutProps> = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <div className="flex items-start gap-3">{children}</div>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};